module.exports = __webpack_public_path__ + "img/電気回路_5_8_1.77d084a5.png";